import { ComponentDataDestService } from '../component-data-dest.service';
import { ComponentDataSourceService } from '../../component-data-source/component-data-source.service';
import { ModalService } from '../../modal/modal.service';
import { environment } from '../../../environment/environment';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';

export function update_path_user(
  componentDataDestService: ComponentDataDestService,
  componentDataSourceService: ComponentDataSourceService,
  data: any
): Observable<unknown> {
  const pathGuid = data.pathGuid ?? data.path_guid;
  const userUuid = data.userUuid ?? data.user_uuid;

  if (!pathGuid || !userUuid) {
    return new Observable(obs => {
      obs.error(new Error('pathGuid and userUuid are required'));
    });
  }

  const removeUser = data.removeUser === true || data.removeUser === 'true' || data.removeUser === 1;

  componentDataSourceService.clearEducationalPathData();

  if (removeUser) {
    const request$ = componentDataDestService.http.delete(
      `${environment.apiUrl}/paths/${pathGuid}/users/${userUuid}`,
      { withCredentials: true }
    ).pipe(
      tap(() => componentDataSourceService.clearEducationalPathData())
    );
    const result$ = componentDataSourceService.updateStoreData(request$, 'educational_path_users');
    const modalService = componentDataDestService.injector.get(ModalService);
    return result$.pipe(
      tap(() => modalService.closeAllModals())
    );
  }

  const body: Record<string, unknown> = {};
  if (data.requirement_started_at !== undefined && data.requirement_started_at !== '' && data.requirement_started_at !== null) {
    let val = data.requirement_started_at;
    if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
      val = val + 'T00:00:00.000Z';
    }
    body['requirement_started_at'] = val;
  }
  if (data.maintenance_started_at !== undefined && data.maintenance_started_at !== '' && data.maintenance_started_at !== null) {
    let val = data.maintenance_started_at;
    if (typeof val === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(val)) {
      val = val + 'T00:00:00.000Z';
    }
    body['maintenance_started_at'] = val;
  }
  if (data.version_id !== undefined && data.version_id !== '' && data.version_id !== null) {
    body['version_id'] = typeof data.version_id === 'number' ? data.version_id : parseInt(data.version_id, 10);
  }

  const request$ = componentDataDestService.http.patch(
    `${environment.apiUrl}/paths/${pathGuid}/users/${userUuid}`,
    { user: body },
    { withCredentials: true }
  ).pipe(
    tap(() => componentDataSourceService.clearEducationalPathData())
  );

  const result$ = componentDataSourceService.updateStoreData(request$, 'educational_path_users');
  const modalService = componentDataDestService.injector.get(ModalService);
  return result$.pipe(
    tap(() => modalService.closeAllModals())
  );
}
